import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Edit from 'react-icons/lib/md/edit';
import Trash from 'react-icons/lib/fa/trash';
import Button from 'react-bootstrap/lib/Button';
import Checkbox from 'react-bootstrap/lib/Checkbox';
import Upload from 'react-icons/lib/fa/upload';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import ProgressBar from 'react-bootstrap/lib/ProgressBar';
import PhotoForm from './PhotoForm';
import Modal from 'react-bootstrap/lib/Modal';
import { get, capitalize } from 'lodash';
import { defaultMessages } from '../../../../libs/i18n/default';


class ResidentCertificateUpload extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showModal: false,
      submitted: false,
      certificate: null,
      termsAccepted: false
    }
    this.certificate_name = this.props.resident.vaccination.certificate_name
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.loadingAnimation = this.loadingAnimation.bind(this);
    this.handleFileSelection = this.handleFileSelection.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  open() {
    this.setState({ showModal: true });
  }

  loadingAnimation() {
    if (this.state.submitted) {
      return (<i className='fa fa-spinner fa-spin fa-lg fa-fw'></i>)
    }
  }

  handleFileSelection(e) {
    this.setState({ certificate: e.target.files[0] })
  }

  handleSubmit(e) {
    e.preventDefault()

    let payload = {
      form: {
        authenticity_token: ReactOnRails.authenticityToken(),
        host_id: this.props.user.host.id,
        resident_id: this.props.resident.id,
        attachment: {
          name: `Covid ${_.capitalize(this.certificate_name)} Certificate - ${this.props.resident.name}`,
          kind: `covid_${this.certificate_name}_certificate`,
          file: this.state.certificate
        }
      }
    }

    this.setState({ submitted: true })

    this.props.onCertificateFormSubmit(payload)
  }

  render() {
    const { formatMessage } = this.props.intl
    const LoadingAnimation = this.loadingAnimation()

    return (
      <>
        <small>{
          this.props.content.territory_code.toLowerCase() === "nz"
            ? "You may upload your vaccination pass here. This is optional."
            : "Please upload a certificate."
        }</small>
        <Button bsSize="xsmall" onClick={this.open}>
          <Upload /> {_.capitalize(this.certificate_name)} certificate
        </Button>
        <Modal show={this.state.showModal} onHide={this.close}>
          <Modal.Header closeButton>
            <Modal.Title>Upload {_.capitalize(this.certificate_name)} certificate</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit}>
              <FormGroup>
                <ControlLabel>Certificate</ControlLabel>
                <FormControl
                  id="file"
                  type="file"
                  componentClass="input"
                  onChange={this.handleFileSelection}
                />
              </FormGroup>

              <Checkbox
                id="termsAccepted"
                checked={this.state.termsAccepted}
                onChange={() => this.setState({ termsAccepted: !this.state.termsAccepted })}
                required
              >
                {ReactHtmlParser(formatMessage(
                  defaultMessages.clientHostPagesResidentsLabelsCovidTermsAccepted,
                  {name: this.props.territory.short_name}
                ))}
              </Checkbox>

              {this.props.uploader.progress && (
                <ProgressBar now={this.props.uploader.progress} label={`${this.props.uploader.progress}%`} active striped />
              )}

              <Button type="submit" id="photo-submit" className="btn-primary" disabled={this.state.submitted || !this.state.termsAccepted}>
                {LoadingAnimation} Upload
              </Button>
            </form>
          </Modal.Body>
        </Modal>
      </>
    )
  }
};

export default ResidentCertificateUpload;
